import script from "./Card1.vue?vue&type=script&setup=true&lang=js"
export * from "./Card1.vue?vue&type=script&setup=true&lang=js"

import "./Card1.vue?vue&type=style&index=0&id=aa0df20a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa0df20a"]])

export default __exports__